import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageChannelService, BnLoadingService, EntityPagedResult, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { map } from 'rxjs/operators';

import { TarefasRelatoriosService } from './tarefas.relatorios.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { ModalidadeGarantia } from '../../../model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { Tranche } from '../../../model/tranche.model';
import { JanelaApuracaoService } from 'src/app/shared/services/janela-apuracao.service';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { MensagemService } from '../../mensagem.service';
import { FeaturesService } from '../../features.service';

@Component({
    selector: 'app-tarefas-relatorios',
    templateUrl: './tarefas-relatorios.component.html',
    styleUrls: ['./tarefas-relatorios.component.scss'],
    standalone: false
})
export class TarefasRelatoriosComponent implements OnInit {

  ocorrencias:OcorrenciaValidacaoVO[] = [];

  private podeEscolherAgente: boolean = false;
  public ehAgenteFinanceiro: boolean = false;

  cnpjUsuario: string;

  public pesquisado: boolean; // usado no html

  public modalidade: ModalidadeGarantia;

  public janelasApuracaoTaxaMedia: JanelaApuracaoTaxaMediaMaximaAgente[];
  public ideJanelaSelecionada: number;

  public agentesFinanceiros: AgenteFinanceiro[];
  public ideAgenteSelecionado: number;
  public apenasSimulacao : boolean;

  public tranches: Tranche[];
  public trancheSelecionada: Tranche;
  public ideTranche: number;
  public salvarResultado: boolean;
  public cnpjInfoRisco: string;

  public features: Map<String, boolean>;
  public tarefasRelatoriosHabilitadas: boolean;
  public tarefaRelatoriosExposicaoLimiteHabilitada: boolean;
  public tarefaRelatoriosValorNaoComprometidoHabilitada: boolean;
  public checkGravarGeracaoRelatorioValorNaoComprometido: boolean = false;
  @ViewChild('mensagemGravarGeracaoRelatorioValorNaoComprometido') mensagemGravarGeracaoRelatorioValorNaoComprometido: TemplateRef<any>;
  @ViewChild('botoesGravarGeracaoRelatorioValorNaoComprometido') botoesGravarGeracaoRelatorioValorNaoComprometido: TemplateRef<any>;

  // modelo do formulario

  private valoresPesquisaForm: any;

  private totalObjetosRetornados: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: TarefasRelatoriosService,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private messageService: MensagemService,
    private modalidadeService: ModalidadeGarantiaService,
    private trancheService: TrancheService,
    private janelaTaxaMediaService: JanelaApuracaoService,
    private bnModalService: BnModalMessageService) {

     this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver

     this.features = this.activatedRoute.snapshot.data['features']; //resolver
     this.tarefasRelatoriosHabilitadas = this.features['tarefasRelatorios'] === "true";
     this.tarefaRelatoriosExposicaoLimiteHabilitada = this.features['tarefasRelatoriosExposicaoLimites'] === "true";
     this.tarefaRelatoriosValorNaoComprometidoHabilitada = this.features['tarefasRelatoriosValorNaoComprometido'] === "true";
  }

  ngOnInit() {

    this.modalidadeService.buscarModalidade().subscribe((mod: any) => {
      this.modalidade = mod;
    });

    this.trancheService.getTranches().subscribe (tranches => {
      this.tranches = tranches;
    });

    this.janelaTaxaMediaService.buscarJanelasApuracao().subscribe(janelas => {
      this.janelasApuracaoTaxaMedia = janelas ? janelas : null;
    });

    this.apenasSimulacao = true;
    this.ideAgenteSelecionado = null;

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario && usuario.cnpj;
    });
  }

  gerarRelatoriosResgatesUniao2022EmDiante() {
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    if (this.bnModalService.modal != null) {
      this.bnModalService.dismiss();
    }

    this.service.gerarRelatoriosResgatesUniao2022EmDiante(this.checkGravarGeracaoRelatorioValorNaoComprometido).subscribe(() => {
      this.messageService.adicionarMensagemSucesso('Agendamento da apuração realizado com sucesso. Horário previsto de execução: entre 20h e 5h.');
      this.loadingService.liberaTela();
    }, (error) => {
      console.log(error);
       this.ocorrencias = this.service.ocorrencias;
       this.loadingService.liberaTela();
    });
  }

  abrirModalGerarRelatoriosResgatesUniao2022EmDiante() {
    if (this.checkGravarGeracaoRelatorioValorNaoComprometido) {
      this.gerarRelatoriosResgatesUniao2022EmDiante();
    } else {
      this.bnModalService.abrir('Confirmação', null, 'md', this.mensagemGravarGeracaoRelatorioValorNaoComprometido, this.botoesGravarGeracaoRelatorioValorNaoComprometido);
    }
  }


  gerarRelatorioTaxaMediaMaxima(ideJanelaApuracao: number,apenasSimulacao: boolean, ideAgenteFinanceiro?: number) {
    const params: any = {};
    this.loadingService.bloqueiaTela();
    if(ideAgenteFinanceiro != null) {
      params.ideAgenteFinanceiro =ideAgenteFinanceiro;
    }
    params.apenasSimulacao = apenasSimulacao;
    this.service.gerarRelatorioTaxaMediaMaxima(ideJanelaApuracao,params).subscribe((retorno) => {
      this.messageService.adicionarMensagemSucesso(`${retorno.mensagem}`);
      this.loadingService.liberaTela();
    }, (error) =>{
      this.loadingService.liberaTela();
    });
  }

  reabrirJanelaApuracaoTaxaMediaMaxima(ideJanelaApuracao: number) {
    const params: any = {};
    this.loadingService.bloqueiaTela();
    this.service.reabrirJanelaApuracaoTaxaMediaMaxima(ideJanelaApuracao).subscribe(retorno => {
      this.messageService.adicionarMensagemSucesso(`${retorno.mensagem}`);
      this.loadingService.liberaTela();
    }, (error) =>{
      this.loadingService.liberaTela();
    });
  }

  public gerarRelatorioSaldoGarantidoCreditoLivre() {
    this.loadingService.bloqueiaTela();
    this.service.gerarRelatorioSaldoGarantidoCreditoLivre().subscribe(() => {
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
      this.loadingService.liberaTela();
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    })
  }

  public gerarRelatorioSaldoGarantidoRepasse() {
    this.loadingService.bloqueiaTela();
    this.service.gerarRelatorioSaldoGarantidoRepasse().subscribe(() => {
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
      this.loadingService.liberaTela();
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    })
  }

  public gerarRelatorioConfrontoContabilCreditoLivre() {
    this.loadingService.bloqueiaTela();
    this.service.gerarRelatorioConfrontoContabilCreditoLivre().subscribe(() => {
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
      this.loadingService.liberaTela();
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    })
  }

  public gerarRelatorioConfrontoContabilRepasse() {
    this.loadingService.bloqueiaTela();
    this.service.gerarRelatorioConfrontoContabilRepasse().subscribe(() => {
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
      this.loadingService.liberaTela();
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    })
  }

  public gerarRelatorioLimiteExposicao() {
    this.loadingService.bloqueiaTela();
    this.service.gerarRelatorioLimiteExposicao().subscribe(() => {
      this.messageService.adicionarMensagemSucesso('Execução concluída com sucesso. Relatório enviado por e-mail.');
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public gerarRelatorioPengCreditoLivre() {
    this.loadingService.bloqueiaTela();
    this.messageService.adicionarMensagemSucesso('Tafera em execução.O Relatório estará disponivel no diretorio assim que for finalizado, aguarde.');
    this.service.gerarRelatorioPengCreditoLivre().subscribe(() => {
      this.loadingService.liberaTela();
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    });
  }

  public gerarRelatorioPengRepasse() {
    this.loadingService.bloqueiaTela();
    this.messageService.adicionarMensagemSucesso('Tafera em execução. O Relatório estará disponivel no diretorio assim que for finalizado, aguarde.');
    this.service.gerarRelatorioPengRepasse().subscribe(() => {
      this.loadingService.liberaTela();
      this.messageService.adicionarMensagemSucesso('O Relatório está disponivel no diretorio.');
    }, (error) => {
      this.messageService.adicionarMensagemErro(`${error.error[0].mensagem}`);
      this.loadingService.liberaTela();
    });
  }

  public atualizarBaseOperacoesInformacaoRisco() {
    this.loadingService.bloqueiaTela();
    if (this.cnpjInfoRisco) {
      this.service.atualizarBaseOperacoesInformacaoRisco(this.cnpjInfoRisco).subscribe(() => {
        this.messageService.adicionarMensagemSucesso('Tafera em execução. A atualização da base de dados com as informações de risco pode demorar dependendo do agente financeiro.');
        this.loadingService.liberaTela();
      }, (error) => {
        this.loadingService.liberaTela();
        this.messageService.adicionarMensagemErro('Erro ao executar tarefa.');
      });
    }
  }

  cancelarModal() {
    this.bnModalService.dismiss('cancelou modal');
  }

  changeCheck(event) {
    this.checkGravarGeracaoRelatorioValorNaoComprometido = event.target.checked;
  }

}
